import React from "react";

export default function Footer({ children }) {
  return (
    <footer className="bg-primary">
      <div className="container mx-auto">
        <div className="md:py-12 py-8">
          <div className="md:flex items-center justify-between">
            <div className="grid grid-rows-2 text-white md:mx-10 md:text-left text-center">
              <h3>© Kuhaku 2020 - 2023 (RIP 🪦)</h3>
              <p>This is what happens when idealism meets reality. We still think we were onto something.</p>
            </div>
            <div className="flex justify-center space-x-4 md:mr-10 md:pt-auto pt-3">
              {children}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

// SocialItem sub-component
const SocialItem = ({ asset, hyperlink }) => {
  return <a href={hyperlink}>{asset}</a>;
};

Footer.SocialItem = SocialItem;
